module.exports = __webpack_public_path__ + "media/images/flags/tm-9e64e699c5ae93549107cb39dd12dfeb.svg";